import { action, observable } from "mobx";
import { idCounter } from "../WSUtils/util";

/** Locks height of input box while panel is visible,
 * to prevent panel from moving when new values are added. */

export const getInputWithPanelHeightLocker = () => {
  const lockedHeight = observable.box<string>(undefined);

  const heightLockerClassName = `cve-input-with-panel-height-locker-${idCounter()}`;

  const onShow = action(() => {
    const component = document.querySelector(`.${heightLockerClassName}`);

    lockedHeight.set(`${component.clientHeight + 2}px`);
  });
  const onHide = action(() => {
    lockedHeight.set(undefined);
  });

  return {
    heightLockerClassName,
    onShow,
    onHide,
    lockedHeight,
  };
};
